import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'fip-data-card',
  templateUrl: './data-card.component.html',
  styleUrls: ['./data-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DataCardComponent {
  @Input({ required: false }) title: string | undefined;
}
